// Hand-written external Supabase client for Path B Lite hybrid architecture.
// This client targets Kasandra's personal Supabase (under Kinyoudoitall LLC)
// where kin-chat Edge Function lives for App Store compliance reasons.
// All auth + data tables remain on Lovable Cloud's auto-managed Supabase.
import { createClient } from "@supabase/supabase-js";

export const EXTERNAL_SUPABASE_URL = "https://unnzlorzyswiahjlxwqh.supabase.co";
export const EXTERNAL_SUPABASE_PUBLISHABLE_KEY = "sb_publishable_uc5fbCfkRx_CVi5X8zpIGw_97bHH740";

export const externalSupabase = createClient(
  EXTERNAL_SUPABASE_URL,
  EXTERNAL_SUPABASE_PUBLISHABLE_KEY,
);
